import api from './api';

class UserService {
  getSchoolList() {
    return api.get('/api/v1/school/?ordering=school_fullname_en');
  }

  getSchoolListID(schoolID) {
    return api.get('/api/v1/school/'+schoolID+'/');
  }

  getSurveyID(surveyID) {
    return api.get('/api/v1/survey/record/?survey_id='+ surveyID);
    // return api.get('/api/v1/survey/record/', { survey_id: 'SV_3wwyYpVR2MUYiWO'}});
  }

  UploadSurvey(surveyID, responseID) {
    return api.post('/api/v1/survey/', { survey_id: surveyID, response_id: responseID });
  }

  getUploadRecord(formData) {
    // api.interceptors.request.use(function)
    return api.post('/api/v1/upload-record/', formData);
  }

  getVerifyEmail(Etoken) {
    return api.post('/dj-rest-auth/registration/verify-email/', { key: Etoken });
  }

  resetPasswordEmail(resetEmail) {
    return api.post('/dj-rest-auth/password/reset/', { email: resetEmail });
  }

  resetPassword(newPssword,confirmPassword,UID,resetToken){
    return api.post('/dj-rest-auth/password/reset/confirm/', { 
      new_password1: newPssword,
      new_password2: confirmPassword,
      uid: UID,
      token: resetToken
    });

  }

  getDownloadLink(UID) {
    return api({ url: '/api/v1/upload-record/' + UID + '/result/', method: 'GET', responseType: 'blob' })
    //   async getDownloadLink(UID) {
    //     try {
    //       const response = await api({ url:'/api/v1/upload-record/'+UID+'/result/', method: 'GET',responseType:'blob' });
    //       return response;
    //     } catch (err) {
    //       console.log(err)
    //     }
    //   }
  }


}

export default new UserService();
